import plusImg from "../picture/Plus.png";
import linkPictureImg from "../picture/LinkWWW.png";
import documentImg from "../picture/Document.png";
import attachImg from "../picture/Prilog.png";
import text42Img from "../picture/text4.2.png";
import Button from "../AdminPanel/Custom/Button/Button.jsx";

const SettingsEditorSegment5 = ({ data, handleCheckboxChange, handleSetValue }) => {

  if (!data) return null
  
  return (
    <div style={{display: "flex", gap: "40px"}}>
      <div className="se-segment5">
        <div className="se-segment5-buttons">
          <Button style={{width: "20%"}}>
            <img src={attachImg}/>
          </Button>
          <Button style={{width: "40%", position: "relative", opacity: data.document_num === "0" ? 0.5 : 1}}>
            <div className="se-segment5-two-images" style={{display: "flex", alignItems: "center"}}>
              <img src={plusImg} style={{padding: "10px 15px"}}/>
              <img src={documentImg} style={{padding: "5px 10px"}}/>
            </div>
            <div className="se-segment5-buttons-circle">22</div>
          </Button>
          <Button style={{width: "40%", position: "relative", opacity: data.link_num === "0" ? 0.5 : 1}}>
            <div className="se-segment5-two-images" style={{display: "flex", alignItems: "center"}}>
              <img src={plusImg} style={{padding: "10px 15px"}}/>
              <img src={linkPictureImg}/>
            </div>
            <div className="se-segment5-buttons-circle">23</div>
          </Button>
        </div>

        <div className="se-segment5-row1">
          <div className="one-checbox">
            <div className="num-checkbox">22</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_num"
              checked={data["document_num"] == "0"}
              onChange={() => handleSetValue("0", "document_num")}
            />
            <div className="se-segment5-row1-number">0</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_num"
              checked={data["document_num"] == "1"}
              onChange={() => handleSetValue("1", "document_num")}
            />
            <div className="se-segment5-row1-number">1</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_num"
              checked={data["document_num"] == "2"}
              onChange={() => handleSetValue("2", "document_num")}
            />
            <div className="se-segment5-row1-number">2</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_num"
              checked={data["document_num"] == "n"}
              onChange={() => handleSetValue("n", "document_num")}
            />
            <div className="se-segment5-row1-number">n</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="document_filter"
              checked={data.document_filter}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox">26</div>
            <div style={{fontWeight: "bold", fontSize: "16px"}}>+</div>
            <div className="num-checkbox">2.1</div>
          </div>
        </div>

        <div className="se-segment5-row2">
          <div className="one-checbox">
            <div className="num-checkbox">23</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="link_num"
              checked={data["link_num"] == "0"}
              onChange={() => handleSetValue("0", "link_num")}
            />
            <div className="se-segment5-row2-number">0</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="link_num"
              checked={data["link_num"] == "1"}
              onChange={() => handleSetValue("1", "link_num")}
            />
            <div className="se-segment5-row2-number">1</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="link_num"
              checked={data["link_num"] == "2"}
              onChange={() => handleSetValue("2", "link_num")}
            />
            <div className="se-segment5-row2-number">2</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="link_num"
              checked={data["link_num"] == "3"}
              onChange={() => handleSetValue("3", "link_num")}
            />
            <div className="se-segment5-row2-number">3</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="link_num"
              checked={data["link_num"] == "4"}
              onChange={() => handleSetValue("4", "link_num")}
            />
            <div className="se-segment5-row2-number">4</div>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="link_num"
              checked={data["link_num"] == "n"}
              onChange={() => handleSetValue("n", "link_num")}
            />
            <div className="se-segment5-row2-number">n</div>
          </div>
        </div>
      </div>
      <div>
        <img src={text42Img} style={{width: "100%", height: "40px"}}/>
      </div>
    </div>
  );
};

export default SettingsEditorSegment5;